


























































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { Profile, User } from "@/models";
import ProfileMixin from "@/mixins/http/Profile";
import TaxonomyMixin from "@/mixins/Taxonomy";
import TaxonomyValue from "@/interfaces/TaxonomyValue";
import TaxonomySelectV2 from "@/components/TaxonomySelectV2.vue";
import EntrySelect from "@/components/EntrySelect.vue";
import MediaSelect from "@/components/MediaSelect.vue";
import FeatureSelect, {
  FEATURE_SELECT_AUDITEL_MODALITY,
  FEATURE_SELECT_DISPLAY_ADVERTISING_MODALITY,
  FEATURE_SELECT_SPECIAL_INITIATIVES_MODALITY,
  FEATURE_SELECT_AGENCIES_MODALITY,
  FEATURE_SELECT_AGENTS_MODULE_MODALITY,
  FEATURE_SELECT_EBIQUITY_MODALITY,
} from "@/components/FeatureSelect.vue";
import UserSearch from "@/components/UserSearch.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import DialogModal from "@/components/DialogModal.vue";
import VModal from "@/components/VModal.vue";
import AdminCompanySelect from "@/components/AdminCompanySelect.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";

const REQUEST_TAG = "profile";

@Component({
  components: {
    MultiLevelSelect,
    VSwitchButton,
    TaxonomySelectV2,
    EntrySelect,
    MediaSelect,
    FeatureSelect,
    UserSearch,
    ConfirmModal,
    DialogModal,
    VModal,
    AdminCompanySelect,
  },
})
export default class ProfileEditor extends Mixins(ProfileMixin, TaxonomyMixin) {
  @Prop() readonly value!: Profile;
  @Prop({ default: false }) update!: boolean;

  profile: Profile = new Profile({});
  isAgency = false;

  taxonomies: TaxonomyValue = {
    sector: [],
    category: [],
    class: [],
  };

  media = {
    radio: true,
    tv: true,
  };

  busy = false;

  users: {
    formVisible: boolean;
    user: User | null;
    loading: boolean;
  } = {
    formVisible: false,
    user: null,
    loading: false,
  };

  get featureSelectSpecialInitiativesModality() {
    return FEATURE_SELECT_SPECIAL_INITIATIVES_MODALITY;
  }

  get featureSelectAuditelModality() {
    return FEATURE_SELECT_AUDITEL_MODALITY;
  }

  get featureSelectSpecialDisplayAdvertisingModality() {
    return FEATURE_SELECT_DISPLAY_ADVERTISING_MODALITY;
  }

  get featureSelectAgenciesModality() {
    return FEATURE_SELECT_AGENCIES_MODALITY;
  }

  get featureSelectAgentsModuleModality() {
    return FEATURE_SELECT_AGENTS_MODULE_MODALITY;
  }

  get featureSelectEbiquity() {
    return FEATURE_SELECT_EBIQUITY_MODALITY;
  }

  get onlyRadio(): boolean {
    return this.media.radio && !this.media.tv;
  }

  get mediaId(): string | null {
    if (this.media.radio && this.media.tv) {
      return null;
    } else if (this.media.radio) {
      return "1";
    } else {
      return "2";
    }
  }

  get saveDisabled(): boolean {
    return (
      !this.postData.name || (!this.isAgency && this.postData.companyId == null)
    );
  }

  get postData() {
    return {
      name: this.profile.name,
      isAgency: this.isAgency,
      companyId: this.profile.company?.id || null,
      taxonomies: this.mapTaxonomies(this.taxonomies),
      mediaId: this.mediaId,
      features: this.profile.features,
    };
  }

  created() {
    if (this.value.id) {
      this.profile = this.value.clone();

      if (this.profile.media?.id) {
        this.media.radio = this.profile.media.id == "1";
        this.media.tv = this.profile.media.id == "2";
      } else {
        this.media.radio = true;
        this.media.tv = true;
      }

      this.isAgency = this.value.isAgency;

      this.taxonomies = this.mapTaxonomyValue(this.profile.taxonomies);
    } else {
      this.profile = new Profile({});
    }
  }

  async save() {
    this.busy = true;

    try {
      if (this.profile.id) {
        this.profile = await this.updateProfile(
          this.profile.id,
          this.postData,
          REQUEST_TAG
        );
      } else {
        this.profile = await this.createProfile(this.postData, REQUEST_TAG);
      }

      this.$emit("saved", this.profile);
    } finally {
      this.busy = false;
    }
  }

  async confirmDelete() {
    const confirmed = await (
      this.$refs.confirmDeleteModal as ConfirmModal
    ).confirm(
      "Cancellare definitvamente il profilo? Tutti gli utenti associati non potranno più accedere"
    );

    if (confirmed) {
      this.busy = true;

      try {
        await this.deleteProfile(this.profile.id, REQUEST_TAG);
        this.$emit("deleted", this.profile);
      } catch (e) {
        await (this.$refs.errorModal as DialogModal).dialog(
          e.response.data.message
        );
      }

      this.busy = false;
    }
  }

  onTypeToggle(val: boolean) {
    this.isAgency = val;
  }

  onTypeSelected(opt: MultiLevelObject) {
    this.isAgency = opt.id == "agency";
  }

  showUserForm() {
    this.users.user = null;
    this.users.formVisible = true;
    this.$nextTick(() => {
      (this.$refs.userSearch as UserSearch).focus();
    });
  }

  hideUserForm() {
    this.users.formVisible = false;
    this.users.user = null;
  }

  get showClientFields(): boolean {
    return !this.isAgency;
  }

  async addUser() {
    if (this.users.user == null) {
      return;
    }

    const data = {
      userId: this.users.user.id,
    };

    try {
      this.users.loading = true;
      await this.addProfileUser(this.profile.id, data, REQUEST_TAG);

      this.profile.users.push(this.users.user.clone());
      this.hideUserForm();
    } finally {
      this.users.loading = false;
    }
  }

  async removeUser(user: User) {
    const index = this.profile.users.findIndex(
      (element) => element.id == user.id
    );

    if (index >= 0) {
      try {
        this.users.loading = true;
        await this.removeProfileUser(this.profile.id, user.id, REQUEST_TAG);

        this.profile.users.splice(index, 1);
      } finally {
        this.users.loading = false;
      }
    }
  }
}
